module.exports = "<div class=\"grouping-location-popup\">\r\n    <create-edit-popup options=\"options\"></create-edit-popup>\r\n</div>\r\n"